import ProjectShow from "./projectProject";

export default {
  show: ProjectShow,
};
